import { useContext } from "react";

import { Outlet } from "react-router-dom";
import { UserContext } from "../../context";


const PrivateRoute = ({ permission = null, role = null }) => {

    const { actions } = useContext(UserContext);

    if (role) {
        if (!actions.hasRole(role)) {
            window.location.href = "/";
            return
        }
    }
    if (permission) {
        if (!actions.hasPermission(permission)) {
            window.location.href = "/";
            return
        }
    }

    return (

        <>
            {<Outlet />}
        </>
    )
}
export default PrivateRoute;